import React, { useEffect, useState } from 'react';
import {
  InputAdornment,
  IconButton,
  Box,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import * as api from '../../../services/oldApiService';
import {
  isUsedEmail,
} from '../../../common/validationConfig';
import { setCookie } from '../../../common/sessionUtils';
import signUpStyle from './Styles';
import { FormValuesType, planParams } from '../../../types/types';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import SignUpTerms from './SignUpTerms';
import { useGetUserRoles } from 'hooks/useLookups';
import Payment from '../../../common/payPal/PayPal';
function getSteps() {
  return [' Your Info', 'Terms and conditions', 'Verify'];
}

export default function SignUpPage(props: any) {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  // const allClasses = signUpStyle();
  const { planId } = useParams<planParams>();
  const [open, setOpen] = React.useState<boolean>(false);
  const [disabledBack, setIsDisabledBack] = React.useState<boolean>(false);
  const [data, setData] = React.useState();
  const [activeCode, setActiveCode] = useState<boolean>(false);
  const [newPrice, setNewPrice] = useState<number>(0);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [paymentMethod, setPaymentMethod] = React.useState();
  const [resetForm, setResetForm] = React.useState<boolean>(false);
  const [selectedPlan, setSelectedPlan] = useState<any>();
  const [userToken, setUserToken] = useState<string>('');
  const [showAlert, setShowAlert] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<any>([]);
  const [customerId, setCustomerId] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [activeStep, setActiveStep] = React.useState<number>(0);
  const [countryCode, setCountryCode] = React.useState<any>({});
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [isAccept, setIsAccept] = React.useState(false);
  const [sent, setSent] = React.useState<boolean>(false);
  const steps = getSteps();
  const [countries, setCountries] = React.useState<any[]>([]);
  const [formValues, setFormValues] = React.useState<any>({
    accepted_privacy_policy: false,
    accepted_terms: false,
    registered_from: 'WEB',
    countryCode: null,
    phone: '',
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    role: '',
    accountType: 'Individual',
    business_name: '',
    business_description: '',
  });
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [stepOneError, setStepOneError] = React.useState('');
  const [stepTwoError, setStepTwoError] = React.useState('');
  const [accountTypes, setAccountTypes] = React.useState<any>([
    { name: 'Individual' },
    { name: 'Business/Institution' },
  ]);

  let signupSchema = yup.object().shape({
    email: yup
      .string()
      .trim()
      .email('Must use valid email address')
      .required('Email is required')
      .test('is-email-valid', 'Email is already used', async (email) =>
        isUsedEmail(email)
      ),
    first_name: yup.string().required('First name is required'),
    last_name: yup.string().required('Last name is required'),
    password: yup
      .string()
      .required('Password is required')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!.%*+=(){}?&,:;'-])[A-Za-z\d@$#!.%+=(){}*?&,:;'-]{8,}$/,
        'Must Contain 8 Characters, One Uppercase, One Number and one special case Character'
      )
  });

  const { data: role = [] } = useGetUserRoles();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    getValues,
    formState: { errors, isValid }
  } = useForm({
    resolver: yupResolver(signupSchema),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit'
  });
  const watchFields = watch('password');
  useEffect(() => {
    setActiveStep(0);
  }, [countries]);

  useEffect(() => {
    if (planId !== undefined) {
      getPlanByBraintreeId(planId);
      getNewUserToken();
    }
  }, []);

  useEffect(() => {
    if (paymentMethod) {
      handleSubscribe();
    }
  }, [paymentMethod]);

  useEffect(() => { }, [selectedPlan]);

  useEffect(() => {
    if (activeStep === 0 || activeStep > 6) {
      setIsDisabled(true);
    } else if (planId !== undefined && activeStep === 3) {
      setIsDisabled(true);
    } else if (planId === undefined && activeStep === 2) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [activeStep]);

  useEffect(() => {
    if (code.length > 0) {
      if (selectedPlan) {
        validateCoupon(code, selectedPlan?.cost, 'registration');
      } else {
        validateCoupon(code, selectedPlan?.cost, 'registration');
      }
    }
  }, [code, selectedPlan]);

  useEffect(() => {
    setValue('first_name', formValues.first_name);
    setValue('last_name', formValues.last_name);
    setValue('email', formValues.email);
    setValue('password', formValues.password);
  }, [
    formValues.email,
    formValues.first_name,
    formValues.last_name,
    formValues.password,
    resetForm,
    setValue
  ]);

  const onSubmit = (values: any) => {
    setFormValues(values);

    handleNext();
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };
  function handleEnter(event: any) {
    if (event.keyCode === 13) {
      const form = event.target.form;
      const index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  }

  const handleNext = () => {
    setResetForm(false);
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const setLogin = async () => {
    if (user) {
      user.verified = false;
      login(user);
      window.location.reload();
    }
  };

  const handleAccept = async () => {
    formValues['accepted_privacy_policy'] = true;
    formValues['accepted_terms'] = true;
    formValues['registered_from'] = 'WEB';
    if (planId !== undefined) {
      handleNext();
    }
    handleDialogClose();
  };
  const getNewUserToken = React.useCallback(async () => {
    const { data, status_code: statusCode } = await api.getNewUserToken();
    if (statusCode === api.status.SUCCESS) {
      setUserToken(data.token);
      setCustomerId(data.customer_id);
    }
  }, []);

  const getPlanByBraintreeId = React.useCallback(async (planId: string) => {
    const { data, status_code: statusCode } = await api.getPlanByBraintreeId(
      planId
    );
    if (statusCode === api.status.SUCCESS) {
      setSelectedPlan(data);
    }
  }, []);

  const handleSubscribe = async () => {
    if (planId === undefined) {
      handleAccept();
    }
    let payload;
    if (
      formValues['countryCode'] === null ||
      formValues['countryCode'] === '' ||
      formValues['countryCode'] === undefined
    ) {
      if (paymentMethod) {
        if (activeCode) {
          payload = {
            accepted_privacy_policy: formValues['accepted_privacy_policy'],
            accepted_terms: formValues['accepted_terms'],
            email: formValues['email'],
            first_name: formValues['first_name'],
            last_name: formValues['last_name'],
            password: formValues['password'],
            registered_from: formValues['registered_from'],
            customer_id: customerId,
            plan_id: planId,
            payment_method_nonce: paymentMethod,
            promotion_code: code,
            user_role_id: formValues['user_role_id']
          };
        } else {
          payload = {
            accepted_privacy_policy: formValues['accepted_privacy_policy'],
            accepted_terms: formValues['accepted_terms'],
            email: formValues['email'],
            first_name: formValues['first_name'],
            last_name: formValues['last_name'],
            password: formValues['password'],
            registered_from: formValues['registered_from'],
            customer_id: customerId,
            plan_id: planId,
            payment_method_nonce: paymentMethod,
            user_role_id: formValues['user_role_id']
          };
        }
      } else {
        payload = {
          accepted_privacy_policy: formValues['accepted_privacy_policy'],
          accepted_terms: formValues['accepted_terms'],
          email: formValues['email'],
          first_name: formValues['first_name'],
          last_name: formValues['last_name'],
          password: formValues['password'],
          registered_from: formValues['registered_from'],
          user_role_id: formValues['user_role_id']
        };
      }
      if (formValues['user_role_id'] === '') {
        delete payload.user_role_id;
      }

      if (code.toLowerCase() == 'mslogger100') {
        payload.promotion_code = code.toLowerCase();
        payload.plan_id = planId;
      }

      const { status_code: statusCode, data } = await api.signUp(payload);

      if (statusCode === api.status.SUCCESS) {
        if (paymentMethod) {
          setShowAlert(true);
        }
        setMessage(['success', 'Subscribed successfully']);
        setTimeout(() => {
          login(data);
          setShowAlert(false);
          handleNext();
        }, 1000);
      } else {
        setShowAlert(true);
        setMessage(['error', 'Payment method nonce is invalid']);
        setTimeout(() => {
          setShowAlert(false);
        }, 1000);
      }
    } else {
      if (paymentMethod) {
        if (activeCode) {
          payload = {
            accepted_privacy_policy: formValues['accepted_privacy_policy'],
            accepted_terms: formValues['accepted_terms'],
            email: formValues['email'],
            first_name: formValues['first_name'],
            last_name: formValues['last_name'],
            password: formValues['password'],
            registered_from: formValues['registered_from'],
            country_code_lookup_id: formValues['countryCode'],
            phone: formValues['phone'],
            customer_id: customerId,
            plan_id: planId,
            payment_method_nonce: paymentMethod,
            promotion_code: code,
            user_role_id: formValues['user_role_id']
          };
        } else {
          payload = {
            accepted_privacy_policy: formValues['accepted_privacy_policy'],
            accepted_terms: formValues['accepted_terms'],
            email: formValues['email'],
            first_name: formValues['first_name'],
            last_name: formValues['last_name'],
            password: formValues['password'],
            registered_from: formValues['registered_from'],
            country_code_lookup_id: formValues['countryCode'],
            phone: formValues['phone'],
            customer_id: customerId,
            plan_id: planId,
            payment_method_nonce: paymentMethod,
            user_role_id: formValues['user_role_id']
          };
        }
      } else {
        payload = {
          accepted_privacy_policy: formValues['accepted_privacy_policy'],
          accepted_terms: formValues['accepted_terms'],
          email: formValues['email'],
          first_name: formValues['first_name'],
          last_name: formValues['last_name'],
          password: formValues['password'],
          registered_from: formValues['registered_from'],
          country_code_lookup_id: formValues['countryCode'],
          phone: formValues['phone'],
          user_role_id: formValues['user_role_id']
        };
      }

      if (code.toLowerCase() == 'mslogger100') {
        payload.promotion_code = code.toLowerCase();
        payload.plan_id = planId;
      }

      const { status_code: statusCode, data } = await api.signUp(payload);
      if (statusCode === api.status.SUCCESS) {
        if (paymentMethod) {
          setShowAlert(true);
        }
        setMessage(['success', 'Subscribed successfully']);
        setTimeout(() => {
          setShowAlert(false);
          login(data);
          handleNext();
        }, 1000);
      } else {
        if (paymentMethod) {
          setShowAlert(true);
        }
        setMessage(['error', 'Payment method nonce is invalid']);
        setTimeout(() => {
          setShowAlert(false);
          handleNext();
        }, 1000);
      }
    }
  };

  const resendVerifyLink = async () => {
    setActiveStep(6);
    const { status_code: statusCode, data } = await api.resendVerificationCode(
      user.id
    );
    if (statusCode === api.status.SUCCESS) {
      handleNext();
    } else {
    }
    handleNext();
  };

  const getCountries = async () => {
    if (countries.length === 0) {
      const { data } = await api.getCountries();
      setCountries(data);
    }
  };

  const validateCoupon = React.useCallback(async (code: any, price: any, flow: any) => {
    const { data, status_code: statusCode } = await api.validateCoupon(
      code,
      price,
      flow
    );
    if (statusCode === api.status.SUCCESS) {
      setActiveCode(true);
      setNewPrice(data.new_price);
    } else if (statusCode === api.status.BAD_REQUEST) {
      setActiveCode(false);
      setNewPrice(price);
    }
  }, []);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setResetForm(true);
  };
  const handleChange = () => {
    setIsAccept(!isAccept);
  };
  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const inputProps = {
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          className='showPassword'
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    )
  };

  const nextStep = async (step: number) => {
    switch (step) {
      case 1:
        if (await validateStepOne()) {
          setActiveStep(1);
        } else {
          scrollToTop();
        }
        break;
      case 2:
        if (validateStepTwo()) {
          if (selectedPlan) {
            if (code.toLowerCase() == 'mslogger100') {
              setActiveStep(3);
              handleSubscribe();
            } else {
              setActiveStep(2);
            }
          } else {
            setActiveStep(3);
            handleSubscribe();
          }
        } else {
          scrollToTop();
        }
        break;
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  const handleInputChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormValues({
      ...formValues,
      [name]: newValue,
    });
  };

  const isValidEmail = (email: string) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const isEmailAvailable = async (email: string) => {
    if (email) {
      const { data } = await api.checkEmailAvailability(email);
      return data?.available == true;
    }
    return false;
  }

  const validateStepOne = async () => {
    setStepOneError('');
    const isAvailable = await isEmailAvailable(formValues.email)
    if (formValues.first_name === '') {
      setStepOneError('First name is required');
      return false;
    } else if (formValues.last_name === '') {
      setStepOneError('Last name is required');
      return false;
    } else if (formValues.role === '') {
      setStepOneError('Role is required');
      return false;
    } else if (formValues.email === '' || !isValidEmail(formValues.email)) {
      setStepOneError('Invalid email address');
      return false;
    } else if (formValues.password.length < 8) {
      setStepOneError('Password should be at least 8 characters')
      return false;
    } else if (!isAvailable) {
      setStepOneError('Email is already associated with another account')
      return false;
    }

    return true;
  }

  const validateStepTwo = () => {
    setStepTwoError('');
    if (formValues.accepted_privacy_policy === false) {
      setStepTwoError('Please agree to the terms and conditions before proceeding.');
      return false;
    }
    return true;
  }

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <form onChange={handleInputChange}>
            <h1>Sign Up</h1>

            {stepOneError ? (<div className="errorMessage">
              <p>{stepOneError}</p>
            </div>) : null}

            <div className="form-group">
              <label htmlFor="firstName">First Name <sup>*</sup></label>
              <input name="first_name" defaultValue={formValues.first_name} type="text" id="firstName" className="form-control" required></input>
            </div>

            <div className="form-group">
              <label htmlFor="lastName">Last Name <sup>*</sup></label>
              <input name="last_name" defaultValue={formValues.last_name} type="text" id="lastName" className="form-control" required></input>
            </div>

            <div className="form-group">
              <label htmlFor="role">Role <sup>*</sup></label>
              <select name="role" defaultValue={formValues.role} id="role" className="form-control">
                <option value="">-- Select Option --</option>
                {role.map((roleItem: any) => (
                  <option key={roleItem.key} value={roleItem.value}>{roleItem.label}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="emailAddress">Email <sup>*</sup></label>
              <input name="email" defaultValue={formValues.email} type="email" id="emailAddress" className="form-control" required></input>
            </div>
            <div className="form-group">
              <label htmlFor="password">Password <sup>*</sup></label>
              <input name="password" defaultValue={formValues.password} type="password" id="password" className="form-control" required></input>
            </div>
            <div className="form-group strong">
              <div className="strongPassword">
                <p>Strong password</p>
              </div>
              <label htmlFor="promotionalCode">Promotional code</label>
              <input onChange={(event) => setCode(event.target.value)} value={code} type="text" id="promotionalCode" className="form-control"></input>
            </div>

            <div className="navigationBtn d-flex justify-content-between align-items-center">
              <ul className="d-flex mx-auto">
                <li className="dots active"></li>
                <li className="dots"></li>
                <li className="dots"></li>
                <li className="dots"></li>
              </ul>
              <button type="button" className="nextBtn" onClick={() => nextStep(1)}>Next</button>
            </div>

          </form>
        );
      case 1:
        return (
          <div>
            <div className="item">
              <h1>Sign Up</h1>

              {stepTwoError ? (<div className="errorMessage">
                <p>{stepTwoError}</p>
              </div>) : null}

              {/* // signup terms */}
              <SignUpTerms />
              <div className="acceptTerms d-flex align-items-center justify-content-between">
                <div className="acceptContent">
                  <p>I have read and accept <a onClick={() => window.open('https://www.mslogger.com/privacy/', '_blank')} className='pointer'>Privacy Policy</a></p>
                </div>
                <div className="custom-control custom-switch">
                  <div className="toggle">
                    <input onChange={handleInputChange} defaultChecked={formValues.accepted_privacy_policy} name="accepted_privacy_policy" type="checkbox" id="agree" required></input>
                  </div>
                </div>
              </div>
            </div>

            <div className="navigationBtn d-flex justify-content-between align-items-center">
              <button type="button" className="prevbtn" onClick={() => setActiveStep(0)}>Previous</button>
              <ul className="d-flex">
                <li className="dots"></li>
                <li className="dots active"></li>
                <li className="dots"></li>
                <li className="dots"></li>
              </ul>
              <button type="button" className="nextBtn" onClick={() => nextStep(2)}>Next</button>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <div className="item">
              <div className="item bgCardImg">
                <h1>Billing Info</h1>

                <div className="billingInfo">
                  <p>Enter your billing information to renew <b>({selectedPlan?.plan?.name})</b> plan</p>
                </div>
                <div className="moderateVal">
                  <h5>{selectedPlan?.plan?.name ? selectedPlan?.plan?.name : 'Free'}</h5>
                  <p>${selectedPlan?.cost}/{selectedPlan?.period}</p>
                </div>
                <div className="payment text-center">
                  <h4>Pay using PayPal</h4>
                  <p>You will be directed to the secure PayPal payment screen</p>
                </div>
                <Box>
                  <Payment
                    planId={planId}
                    setPaymentMethod={setPaymentMethod}
                    clientToken={userToken}
                    customerId={customerId}
                  />
                </Box>
              </div>
            </div>

            <div className="navigationBtn d-flex justify-content-between align-items-center">
              <button type="button" className="prevbtn" onClick={() => setActiveStep(1)}>Previous</button>
              <ul className="d-flex">
                <li className="dots"></li>
                <li className="dots"></li>
                <li className="dots active"></li>
                <li className="dots"></li>
              </ul>
              <button type="button" disabled={true} className="nextBtn" onClick={() => setActiveStep(3)}>Next</button>
            </div>
          </div>
        );
      case 3:
        return (
          <div>

            <div className="item">

              <h1>Sign Up</h1>

              <div className="verification text-center">

                <div className="varifyImg">

                  <img src="assets/img/Ms-verify-img.png" alt=""></img>

                </div>

                <p>In order to continue to MS Logger, you must verify your account.</p>

                <p>An email has been sent to {formValues.email} with a link to verify your account.</p>

                <p>If you have not received the verification email after a few minutes, Please check your spam folder.</p>

                <div className="resendMail">

                  <a onClick={() => resendVerifyLink()} className="pointer">Re-send the verfication email</a>

                </div>

              </div>

            </div>



            <div className="navigationBtn d-flex justify-content-between align-items-center">

              <button type="button" className="prevbtn" disabled={true}>Previous</button>

              <ul className="d-flex">

                <li className="dots"></li>

                <li className="dots"></li>

                <li className="dots"></li>

                <li className="dots active"></li>

              </ul>

              <button type='submit' onClick={() => setLogin()}>Finish</button>

            </div>

          </div>
        );
      default:
        return (
          <div>

            <div className="item">

              <h1>Sign Up</h1>

              <div className="verification text-center">

                <div className="varifyImg">

                  <img src="assets/img/Ms-verify-img.png" alt=""></img>

                </div>

                <p>In order to continue to MS Logger, you must verify your account.</p>

                <p>An email has been sent to {formValues.email} with a link to verify your account.</p>

                <p>If you have not received the verification email after a few minutes, Please check your spam folder.</p>

                <div className="resendMail">

                  <a onClick={() => resendVerifyLink()} className="pointer">Re-send the verfication email</a>

                </div>

              </div>

            </div>



            <div className="navigationBtn d-flex justify-content-between align-items-center">

              <button type="button" className="prevbtn" disabled={true}>Previous</button>

              <ul className="d-flex">

                <li className="dots"></li>

                <li className="dots"></li>

                <li className="dots"></li>

                <li className="dots active"></li>

              </ul>

              <button type='submit' onClick={() => setLogin()}>Finish</button>

            </div>

          </div>
        );
    }
  };

  return (
    <section className="signUp">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="contactForm">
              {getStepContent(activeStep)}
            </div>

          </div>

        </div>

      </div>

    </section>
  );
}
